<template>
  <div>
    <div class="search-box min">
      <div class="form">
        <div class="input-item" v-if="userInfo.levelCode != '10002'">
          <span class="label">机构</span>
          <Select v-model="searchObj.orgId" @on-change="search">
            <Option :value="item.id" v-for="item in orgList" :key="item.id">{{ item.name }}</Option>
          </Select>
        </div>

        <div class="input-item">
          <span class="label">产品名称</span>
          <Input class="value" v-model="searchObj.productName" placeholder="请输入" clearable />
        </div>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="search">查询</Button>
        <Button type="warning" @click="$refs.addRef.open()">新增</Button>
        <Button type="warning" @click="visible = true">{{ statusType }}</Button>
      </div>
    </div>

    <span class="tips-text" v-if="tabsListOne.length">提示：拖动分类可改变顺序。</span>
    <div class="tabs-one">
      <div class="tab-pane" :class="searchObj.firstTag ? '' : 'tab-active'" @click="clearLevelOneActive">
        <a class="all-text">全部</a>
      </div>
      <draggable v-model="tabsListOne" class="tools-list" @update="tabSortEvent(tabsListOne)" v-if="tabsListOne.length" @drop.native.stop>
        <div
          class="tab-pane"
          :class="item.systemThemeId == searchObj.firstTag ? 'tab-active' : ''"
          v-for="item in tabsListOne"
          :key="item.systemThemeId"
          @click="changeTabsOne(item.systemThemeId)"
        >
          <a>{{ item.name }}</a>
        </div>
      </draggable>
    </div>

    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="table-box setTable">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="sellTypeSlot">
          <div class="sellTypeColumn" v-if="row.sellType">
            <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
            <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
          </div>
          <div v-else>-</div>
        </template>

        <template slot-scope="{ row }" slot="sort">
          <Input v-model="row.orderNum" :min="0" type="number" @on-blur="blurSort(row)" />
        </template>

        <template slot-scope="{ row }" slot="action">
          <a @click="remove(row)">移除</a>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page :total="total" :current="searchObj.pageNo" :page-size="searchObj.pageSize" show-total @on-change="pageChange" style="text-align: center" />
    </div>

    <!-- 新增 -->
    <add-hot-product ref="addRef" :getProductList="queryTabOneList" :userInfo="userInfo"></add-hot-product>

    <Modal v-model="visible" :footer-hide="true" :mask-closable="false" width="360px" class="my-modal top">
      <div style="padding: 30px 0;"> 是否开启热销产品自动同步？</div>
      <div class="ivu-modal-footer">
        <Button type="primary" @click="synchronization(1)">是</Button>
        <Button type="text" @click="synchronization(0)">否</Button>
        
      </div>
    </Modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import filter from '@/api/filter';
import addHotProduct from './components/addHotProduct';
export default {
  name: 'hotProductConfig',
  components: {
    draggable,
    addHotProduct
  },
  filter,
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.getItem('userInfo')),
      total: 0,
      statusType:'未同步',
      visible:false,
      searchObj: {
        pageNo: 1,
        pageSize: 10
      },
      tabsListOne: [],
      tableData: [],
      orgList: [],
      columns: []
    };
  },
  created() {
    this.queryOrgList();
    let col = [
      {
        title: '产品名称',
        align: 'center',
        minWidth: 300,
        tooltip: true,
        key: 'productName',
        render(h, params) {
          let text = params.row.productName;
          return h(
            'Tooltip',
            {
              class: 'flex-center',
              props: { placement: 'bottom-start', transfer: true }
            },
            [
              h(
                'span',
                {
                  class: 'txt-ellipsis2'
                },
                text
              ),
              h('span', { slot: 'content' }, text)
            ]
          );
        }
      },
      {
        title: '产品编码',
        align: 'center',
        minWidth: 120,
        key: 'productCode'
      },
      {
        title: '销售类型',
        align: 'center',
        minWidth: 120,
        slot: 'sellTypeSlot'
      },
      {
        title: '保险公司',
        minWidth: 140,
        align: 'center',
        key: 'companyName'
      },
      {
        title: '展业端分类',
        minWidth: 140,
        align: 'center',
        render(h, params) {
          const themeName = params.row.themeName;
          return <span>{themeName ? themeName : '-'}</span>;
        }
      },
      {
        title: '供应商',
        minWidth: 160,
        align: 'center',
        render(h, params) {
          const source = params.row.source;
          return <span>{source ? source : '-'}</span>;
        }
      },
      {
        title: '状态',
        minWidth: 120,
        align: 'center',
        render(h, params) {
          const publishStatus = params.row.publishStatus;
          return <span>{publishStatus == '1' ? '已下架' : '已上架'}</span>;
        }
      },
      {
        title: '排序',
        minWidth: 160,
        align: 'center',
        slot: 'sort'
      },
      {
        title: '操作',
        minWidth: 80,
        align: 'center',
        slot: 'action',
        fixed: 'right'
      }
    ];
    if (!this.$units.superviseShowVal()) {
      col.splice(5, 1);
    }
    this.columns = col;
    this.getStatusType()
  },
  methods: {
    getStatusType(){
      this.$http({
        url: `/buz/tenantSyncConfig/queryConfig`,
        type: 'GET'
      }).then(res => {
        if(res.data.syncStatus == 0){
          this.statusType = '未同步'
        }else if(res.data.syncStatus == 1){
          this.statusType = '同步中'
        }
        
      });
    },
    synchronization(val){
      this.$http({
        url: `/buz/tenantSyncConfig/updateConfig`,
        type: 'GET',
        data:{
          syncStatus:val
        }
      }).then(res => {
        this.visible = false
        this.getStatusType()
      });
    },
    // 处理请求参数
    setRequestParam() {
      let obj = JSON.parse(JSON.stringify(this.searchObj));
      if (obj.orgId.length) {
        obj.orgId = obj.orgId;
      } else {
        obj.orgId = '';
      }
      let { ...params } = obj;
      return params;
    },

    // 机构查询
    queryOrgList() {
      this.$http({
        url: '/buz/organizationBase/read/sub',
        data: {},
        type: 'POST'
      }).then(res => {
        this.orgList = res.data;
        this.searchObj = {
          ...this.searchObj,
          orgId: res.data && res.data[0].id
        };
        this.queryTabOneList();
      });
    },

    // 查询一级tab分类
    queryTabOneList(search) {
      this.searchObj = {
        ...this.searchObj,
        firstTag: !search ? '' : this.searchObj.firstTag
      };
      this.$http({
        url: `/buz/hotProductTheme/array/first?orgId=${this.userInfo.levelCode != '10002' ? this.searchObj.orgId : this.userInfo.organId}`,
        type: 'GET'
      }).then(res => {
        this.tabsListOne = res.data;
        this.getProductList();
      });
    },

    // 查询产品列表
    getProductList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/hotProductConfig/read/page',
        data: this.setRequestParam(),
        type: 'POST',
        apiPermissionCode: 'operate_3_0'
      }).then(res => {
        this.total = res.total;
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 查询
    search() {
      this.searchObj.pageNo = 1;
      this.queryTabOneList(true);
    },

    // 切换一级tab
    changeTabsOne(systemThemeId) {
      this.searchObj.firstTag = systemThemeId;
      this.searchObj.pageNo = 1;
      this.getProductList();
    },

    // 点击一级全部
    clearLevelOneActive() {
      this.searchObj = {
        ...this.searchObj,
        firstTag: ''
      };
      this.getProductList();
    },

    // 排序
    blurSort(data) {
      if (!data.orderNum) return;
      if (data.orderNum < 0) {
        data.orderNum = 0;
      }
      this.$http({
        url: '/buz/hotProductConfig/edit',
        type: 'POST',
        data: {
          productCode: data.productCode,
          orgId: this.searchObj.orgId ? this.searchObj.orgId : '',
          orderNum: data.orderNum,
          id: data.id
        }
      }).then(res => {
        this.$notice.success('修改成功');
        this.getProductList();
      });
    },

    // tab拖动排序
    tabSortEvent(list) {
      this.$http({
        url: '/buz/hotProductTheme/sort',
        type: 'POST',
        data: {
          productThemeVOS: list,
          orgId: this.searchObj.orgId
        }
      });
    },

    // 移除
    remove(item) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: `/buz/hotProductConfig/del?productCode=${item.productCode}&orgId=${this.searchObj.orgId ? this.searchObj.orgId : ''}`,
          type: 'GET',
          apiPermissionCode: 'operate_3_4'
        }).then(res => {
          this.$Message.success('移除成功');
          this.getProductList();
        });
      });
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.getProductList();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-footer{
  border-radius: 6px;
}
.tips-text {
  display: block;
  font-size: 12px;
  margin: 12px 0;
}
.tabs-one {
  width: 100%;
  border-bottom: 1px solid #ececec;
  display: flex;
  margin-bottom: 20px;
  .tools-list {
    display: flex;
  }
  .tab-pane {
    position: relative;
    margin-right: 40px;
    height: 30px;
    a {
      font-size: 14px;
      color: #515c6f;
    }
    .all-text {
      cursor: auto;
    }
  }
  & .tab-active {
    border-bottom: 2px solid #236dff;
    a {
      color: #236dff;
    }
  }
  .right {
    position: absolute;
    top: -5px;
    right: 0;
    .import-btn {
      margin-right: 10px;
      width: 80px;
      height: 30px;
      border: none;
      background-color: #f59045;
      color: #fff;
      border-radius: 2px;
    }
    .export-btn {
      width: 80px;
      height: 30px;
      color: #fff;
      border: none;
      border-radius: 2px;
      background-color: #55bc41;
    }
  }
}

.tabs {
  display: flex;
  margin-top: 10px;
  margin-bottom: 15px;
  .tools-list {
    display: flex;
  }
  .tab-pane {
    position: relative;
    padding: 4px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-right: 10px;
    background-color: #f7f8fa;
    font-size: 12px;
    a {
      color: #727c8e;
    }
  }
  & .active-tab {
    background-color: #236dff;
    a {
      color: #ffffff;
    }
  }
}

.setTable {
  /deep/ .ivu-input {
    width: 100px;
    padding-right: 10px;
    text-align: center;
  }
}

.pageBox {
  margin-top: 20px;
}
.action {
  width: 70px;
  display: flex;
  justify-content: space-between;
}
</style>
